import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { Inline } from 'components/base/Text';
import Link from '@material-ui/core/Link';

const Wrapper = styled(Flex)`
  flex-direction: column;
  width: 30rem;
  padding: 1.2rem;
`;

const GitStreamRepositoriesInfoTooltip = () => (
  <Wrapper>
    <Flex padding='0.3rem 0' items='center'>
      <Icon size='large' name='gitStreamGrey' />
      <Inline
        pl='0.6rem'
        size='large'
        lineHeight='1.1rem'
        weight='500'
        color='shuttleGray'
      >
        gitStream
      </Inline>
    </Flex>
    <Inline size='medium' pt='1rem' color='shuttleGray'>
      gitStream is a workflow automation tool that enables you to use YAML
      configuration files to optimize your code review process. Add context to
      PRs, find code experts for reviews, and automate the merge process to
      maximize developer productivity.
      <Link
        href='https://docs.gitstream.cm'
        target='_blank'
        style={{ cursor: 'pointer' }}
      >
        &nbsp;Learn more
      </Link>
    </Inline>
  </Wrapper>
);

export default GitStreamRepositoriesInfoTooltip;
